import React from 'react'
import PropTypes from 'prop-types'
import Detail from './components/Detail'

const ArtcleDetails = (props) => {
  const { category, title, datetime, label, content, regulationNumber } = props
  return (
    <Detail
      category={category}
      title={title}
      datetime={datetime}
      label={label}
      content={content}
      regulationNumber={regulationNumber}
    />
  )
}

// 参数类型
ArtcleDetails.propTypes = {
  category: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  datetime: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  label: PropTypes.oneOfType([PropTypes.arrayOf, PropTypes.node]),
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  regulationNumber: PropTypes.string,
}

ArtcleDetails.defaultProps = {
  category: '',
  title: '',
  datetime: '',
  label: '',
  content: undefined,
  regulationNumber: '',
}

export default ArtcleDetails
